/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumberListItem } from '../../models/access-number-list-item';

export interface GetAccessnumberMinifiedV2$Json$Params {
  'api-version'?: string;
}

export function getAccessnumberMinifiedV2$Json(http: HttpClient, rootUrl: string, params?: GetAccessnumberMinifiedV2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
  const rb = new RequestBuilder(rootUrl, getAccessnumberMinifiedV2$Json.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccessNumberListItem>>;
    })
  );
}

getAccessnumberMinifiedV2$Json.PATH = '/accessnumber/minified-v2';
